import Phase10OrderPage from './Phase10OrderPage';

export default function GbpSetupOrderPage() {
  return <Phase10OrderPage skuCode="gbp-setup" />;
}
